import _ from "underscore";
//#region src/helpers/base_mongo_helper.ts
let BaseMongoHelper;
(function(_BaseMongoHelper) {
	_BaseMongoHelper.MONGO_ID_REGEX = /^[\da-f]{24}$/i;
	function indexOfId(idArray, mongoId) {
		for (const [index, id] of (idArray || []).entries()) if (mongoId && id.equals(mongoId)) return index;
		return -1;
	}
	_BaseMongoHelper.indexOfId = indexOfId;
	function contains(idArray, mongoId) {
		return indexOfId(idArray, mongoId) >= 0;
	}
	_BaseMongoHelper.contains = contains;
	function stringArrayFromIdArray(array) {
		return array.map((mongoId) => {
			return mongoId.toString();
		});
	}
	_BaseMongoHelper.stringArrayFromIdArray = stringArrayFromIdArray;
	function idArraysAreEqual(idArray1 = [], idArray2 = []) {
		if (idArray1.length !== idArray2.length) return false;
		const idStrArray1 = stringArrayFromIdArray(idArray1);
		const idStrArray2 = stringArrayFromIdArray(idArray2);
		return _.isEqual(idStrArray1, idStrArray2);
	}
	_BaseMongoHelper.idArraysAreEqual = idArraysAreEqual;
	function idArraysIntersectionSize(idArray1, idArray2) {
		const idStrArray1 = stringArrayFromIdArray(idArray1 || []);
		const idStrArray2 = stringArrayFromIdArray(idArray2 || []);
		return _.intersection(idStrArray1, idStrArray2).length;
	}
	_BaseMongoHelper.idArraysIntersectionSize = idArraysIntersectionSize;
	function deepCloneArray(array, bsonUtils) {
		const { isObjectId, toObjectId } = bsonUtils;
		return array.map((value) => {
			if (isObjectId(value)) return toObjectId(value.toString());
			if (_.isArray(value)) return deepCloneArray(value, bsonUtils);
			if (_.isObject(value)) return deepClone(value, bsonUtils);
			return value;
		});
	}
	function deepClone(obj, bsonUtils) {
		const { isObjectId, toObjectId } = bsonUtils;
		const newObj = _.clone(obj);
		_.each(_.keys(newObj), (key) => {
			const value = newObj[key];
			if (isObjectId(value)) newObj[key] = toObjectId(value.toString());
			else if (_.isArray(value)) newObj[key] = deepCloneArray(value, bsonUtils);
			else if (_.isObject(value)) newObj[key] = deepClone(value, bsonUtils);
		});
		return newObj;
	}
	_BaseMongoHelper.deepClone = deepClone;
})(BaseMongoHelper || (BaseMongoHelper = {}));
//#endregion
export { BaseMongoHelper };

//# sourceMappingURL=base_mongo_helper.js.map